import { MutationTree } from "vuex";

import { IUserAccount } from "../userAccount";

import { IState, ICapabilities } from "./state-types";

class Capabilities implements ICapabilities {
    private capabilities: string[];
    constructor(capabilities: string[]) {
        this.capabilities = capabilities;
    }

    checkCapability(capability: string): boolean {
        return this.capabilities.indexOf(capability) > -1;
    }
}

export const mutations: MutationTree<IState> = {
    profileLoaded(state, payload: IUserAccount) {
        state.activeUser = payload;
    },


    setCurrentModelId(state: IState, modelId: string) {
        state.currentModelId = modelId;
    },

    setCapabilities(state: IState, capabilities: string[]) {
        state.capabilities = new Capabilities(capabilities);

    },

    setCurrentNodePath(state: IState, nodePath: string) {
        state.currentNodePath = nodePath;
    },

    setNodeModifiedNotification(state: IState, nodePath: string) {
        state.nodeModifiedNotification = nodePath;
    }

};



// WEBPACK FOOTER //
// ./ClientApp/infrastructure/state/state-mutations.ts